import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'

export default function useLastLogs(deviceId?: string, limit: number = 50) {
  const lastLogsQuery = useQuery({
    queryKey: ['last-logs', deviceId, limit],
    queryFn: () => dataAPI.getLastLogs(deviceId || '', limit),
    enabled: !!deviceId, // Only run query if deviceId is provided
  })

  return {
    lastLogsQuery: {
      data: lastLogsQuery.data,
      isLoading: lastLogsQuery.isLoading,
      isSuccess: lastLogsQuery.isSuccess,
      isError: lastLogsQuery.isError,
      error: lastLogsQuery.error,
      refetch: lastLogsQuery.refetch,
      isRefetching: lastLogsQuery.isRefetching
    }
  }
}

